import React from 'react';
import logo from '../../img/logo.svg';

const PageBodyHeader = (props) => (
  <div className="header">
    <img src={logo} alt="RelianceHMO" />
  </div>
);

export default PageBodyHeader;